import { gql } from "@apollo/client";

export const DISPATCHABLE_OFFICERS = gql`
  query DISPATCHABLE_OFFICERS($incidentId: ID!, $originatorId: ID!) {
    dispatchableOfficers(incidentId: $incidentId, originatorId: $originatorId) {
      __typename
      id
      deptAttribute {
        __typename
        id
        badge
        stateIdNumber
        ori {
          id
          oriName
          abbreviation
          municipalityNumber
        }
        team {
          id
          name
        }
      }
      personalAttribute {
        id
        firstName
        lastName
      }
    }
  }
`;
